import { BasicProductData } from 'components/layout/modals/compatible-combinations-browser-modal';
import { EquipmentPlaceholderKind } from 'utils/equipment-placeholder-kind';

export type CombinationComponentImage = {
  key: string;
  alt: string;
  photo: string | null;
  placeholderKind: EquipmentPlaceholderKind;
};

const COMPONENT_SLOTS: Array<{
  key: string;
  manufacturer: string;
  model: string;
  placeholderKind: EquipmentPlaceholderKind;
}> = [
  {
    key: 'outdoor',
    manufacturer: 'OutdoorManufacturer',
    model: 'OutdoorModelNumber',
    placeholderKind: 'outdoorUnit'
  },
  {
    key: 'indoor',
    manufacturer: 'IndoorManufacturer',
    model: 'IndoorModelNumber',
    placeholderKind: 'evaporatorCoil'
  },
  {
    key: 'blower',
    manufacturer: 'BlowerManufacturer',
    model: 'BlowerModelNumber',
    placeholderKind: 'furnace'
  }
];

const slotText = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : '';

export function combinationComponentImages(
  combination: Record<string, unknown>,
  productData: Record<string, BasicProductData>
): CombinationComponentImage[] {
  return COMPONENT_SLOTS.flatMap((slot) => {
    const manufacturer = slotText(combination[slot.manufacturer]);
    const model = slotText(combination[slot.model]);
    if (manufacturer === '' && model === '') return [];
    const product = productData[`${manufacturer}|${model}`];
    const alt = [manufacturer, model].filter((part) => part !== '').join(' ');
    return [
      {
        key: slot.key,
        alt: product?.name || alt,
        photo: product?.photo ?? null,
        placeholderKind: slot.placeholderKind
      }
    ];
  });
}
